import { Event } from '@iot-platform/models/i4b';

export const WORK_ORDER_EXCLUDED_EVENT_CLASSES: string[] = [
  'LIQDISP',
  'CYLDISP',
  'TUBDISP',
  'GASDISP',
  'CONSO_OC',
  'ALLCUST',
  'CYLDATA',
  'LIQDATA',
  'SCHEDALARM',
  'TASMAINT',
  'UNKOPER',
  'SUBCONTR'
];

const WORK_ORDER_ALLOWED_STATUSES: string[] = ['active', 'acknowledged'];
const WORK_ORDER_ALLOWED_SEVERITIES: string[] = ['medium', 'major', 'critical'];

// Event eligibility for the create-work-order action (asset + status + severity + class).
// Rule 1 (WORKORDER create right) is gated separately via userPermissions; "already requested" is handled via totalWorkorders.
export function canRequestWorkOrder(event: Event): boolean {
  const assetHasSource = !!event?.context?.asset?.source;
  const statusAllowed = WORK_ORDER_ALLOWED_STATUSES.includes((event?.status ?? '').toLowerCase());
  const severityAllowed = WORK_ORDER_ALLOWED_SEVERITIES.includes((event?.severity ?? '').toLowerCase());
  const classAllowed = !WORK_ORDER_EXCLUDED_EVENT_CLASSES.includes((event?.class ?? '').toUpperCase());
  return assetHasSource && statusAllowed && severityAllowed && classAllowed;
}
